/**
 * Detecta se o aplicativo está rodando dentro de um Trusted Web Activity (TWA)
 * (ex: App da Play Store). A detecção é baseada na query string da URL inicial,
 * repassada pela configuração de Bubblewrap, e armazenada no sessionStorage.
 */
export const isTWA = (): boolean => {
  if (typeof window === 'undefined') return false;

  const params = new URLSearchParams(window.location.search);

  // 0. Bypass explícito para links enviados no WhatsApp (Anti-Steering support flow)
  if (params.get('web') === 'true') {
    try {
      sessionStorage.removeItem('ERPLIGHT_IS_TWA');
    } catch {
      // sessionStorage bloqueado (modo privado): nada a limpar.
    }
    return false;
  }

  // 1. Já detectado nesta sessão/aba (Não usar localStorage para não afetar o Chrome padrão)
  try {
    if (sessionStorage.getItem('ERPLIGHT_IS_TWA') === 'true') {
      return true;
    }
  } catch {
    // sessionStorage bloqueado: cai na detecção pela URL/referrer abaixo.
  }

  // 2. Parâmetro na start_url do Bubblewrap ou originário estritamente do nosso app Android
  if (
    params.get('source') === 'twa' ||
    document.referrer.startsWith('android-app://br.app.gestaoleve')
  ) {
    try {
      sessionStorage.setItem('ERPLIGHT_IS_TWA', 'true');
    } catch {
      // Sem sessionStorage a marca não persiste entre rotas; a detecção vale
      // para esta carga.
    }
    return true;
  }

  return false;
};
